export default __webpack_public_path__ + "static/media/deSelectedTickIcon.d420f511.svg";